import React, { memo } from "react"

import { bool } from "prop-types"

import useTranslation from "Pods/ThreeDStudio/Hooks/useTranslation"

import NumericControl from "./Components/NumericControl/NumericControl"
import PreviewUpload from "./Components/PreviewUpload/PreviewUpload"
import SurroundingSelect from "./Components/SurroundingSelect/SurroundingSelect"
import VisibilityToggle from "./Components/VisibilityToggle/VisibilityToggle"
import useEnvironmentSettings from "./Hooks/useEnvironmentSettings"

function EnvironmentSettings({ isOpen }) {
  const t = useTranslation()
  const {
    fileRef,
    environment,
    hasViewerEnvironment,
    isLoggedIn,
    options,
    selectedSurroundingUrl,
    isUploading,
    handleFile,
    handleUploadClick,
    handlePresetChange,
    handleVisibilityChange,
    handleIntensityChange,
    handleRotationChange,
  } = useEnvironmentSettings()

  if (!hasViewerEnvironment || !isOpen) {
    return null
  }

  return (
    <div className="environment-settings">
      <div className="environment-settings__wrapper">
        <h3 className="cgt-heading-50">{t('viewer.environment.title')}</h3>
        <VisibilityToggle
          isChecked={environment?.showBackground}
          onChange={handleVisibilityChange}
        />
        <SurroundingSelect
          options={options}
          value={selectedSurroundingUrl}
          onChange={handlePresetChange}
          disabled={!isLoggedIn}
        />
        <PreviewUpload
          fileRef={fileRef}
          thumbnailUrl={environment?.thumbnailUrl}
          disabled={isUploading}
          onFileChange={handleFile}
          onUploadClick={handleUploadClick}
        />
        <NumericControl
          id="environment-settings-strength"
          label={t('viewer.environment.strength')}
          min={0}
          max={5}
          step={0.1}
          value={environment?.intensity}
          inputSize="small"
          onSliderChange={handleIntensityChange}
          onInputChange={handleIntensityChange}
        />
        <NumericControl
          id="environment-settings-rotation"
          label={t('viewer.environment.rotation')}
          min={0}
          max={360}
          step={1}
          value={environment?.rotation}
          inputSize="small"
          onSliderChange={handleRotationChange}
          onInputChange={handleRotationChange}
        />
      </div>
    </div>
  )
}

EnvironmentSettings.propTypes = {
  isOpen: bool.isRequired,
}

export default memo(EnvironmentSettings)
